// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import CaretDown from "@werner/XDL/Icons/CaretDown";
import CaretUp from "@werner/XDL/Icons/CaretUp";
import { xBaseTheme } from "@werner/XDL/types";
import { color } from "@werner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: { mergeCss: true },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        mergeCss: true,
        collapseIconProps: {
            src: CaretUp,
            size: 14,
            color: "common.ui3",
        },
        expandIconProps: {
            src: CaretDown,
            size: 14,
            color: "common.ui3",
        },
        titleTypographyProps: {
            size: 20,
            weight: 500,
            css: css`
                letter-spacing: 0;
                line-height: 28px;
            `,
        },
        panelProps: {
            css: css`
                border: none;
                padding: 22px 0;
                margin-top: -12px;
                margin-bottom: 12px;
            `,
        },
        headerProps: {
            css: css`
                button {
                    padding: 8px 0;
                    border-bottom: none;
                    border-left: none;
                    border-right: none;
                    background: ${color("common.white")};
                    border-top: 1px solid ${color("common.ui1")};
                }
                ${/* sc-selector */ AccordionSectionPanel} + & button {
                    border-bottom: none;
                    border-left: none;
                    border-right: none;
                    border-top: 1px solid ${color("common.ui1")};
                    &:focus {
                        border-color: ${color("common.ui1")};
                        border-style: solid;
                        border-width: 1px;
                        padding-top: 8px;
                        padding-left: 0;
                        border-bottom: none;
                        border-left: none;
                        border-right: none;
                    }
                }
                button:focus,
                ${AccordionSectionPanel} + & button:focus {
                    border-color: ${color("common.ui1")};
                    border-style: solid;
                    border-width: 1px;
                    padding-top: 8px;
                    padding-left: 0;
                    padding-right: 0;
                    border-bottom: none;
                    border-left: none;
                    border-right: none;
                }

                ${({ expanded }: AccordionSectionHeaderProps) =>
                    !expanded &&
                    css`
                        button,
                        button:focus,
                        ${AccordionSectionPanel} + & button:focus {
                            border-color: ${color("common.ui1")};
                            border-style: solid;
                            border-width: 1px;
                            padding-top: 8px;
                            padding-left: 0;
                            border-bottom: none;
                            border-left: none;
                            border-right: none;
                        }
                    `}
            `,
        },
    },
} as xBaseTheme["accordion"];
